"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eUserRole = exports.eUserRoleLegacyIds = void 0;
const role_class_1 = __importDefault(require("./role.class"));
var eUserRoleLegacyIds;
(function (eUserRoleLegacyIds) {
    eUserRoleLegacyIds["ADMIN"] = "admin";
    eUserRoleLegacyIds["UNDERWRITER"] = "underwriter";
    eUserRoleLegacyIds["DEV"] = "dev";
    eUserRoleLegacyIds["USER"] = "user";
})(eUserRoleLegacyIds = exports.eUserRoleLegacyIds || (exports.eUserRoleLegacyIds = {}));
var eUserRole;
(function (eUserRole) {
    eUserRole["SUPER_USER"] = "ri.superUser";
    eUserRole["ADMIN"] = "ra.admin";
    eUserRole["UNDERWRITER"] = "ri.underwriter";
    eUserRole["COMPLIANCE"] = "ri.compliance";
    eUserRole["CXR"] = "ri.cxr";
    eUserRole["CLAIM_ASSESOR"] = "ri.clAssr";
    eUserRole["DEV"] = "ra.dev";
    eUserRole["MANAGER"] = "ra.mngr";
    eUserRole["USER"] = "ra.user";
    eUserRole["ALL_SETTINGS_MANAGER"] = "ri.allSetMngr";
    eUserRole["BASIC_SETTINGS_MANAGER"] = "ri.bscSetMngr";
    eUserRole["MANAGE_INSURANCE_SETTINGS"] = "ri.insuSetMngr";
    eUserRole["MANAGE_INVOICING_SETTINGS"] = "ri.invoSetMngr";
    eUserRole["VIEW_OCEAN_CARGO_REFERRALS"] = "ri.oceCarRefViewer";
    eUserRole["MANAGE_OCEAN_CARGO_REFERRALS"] = "ri.oceCarRefMngr";
    eUserRole["VIEW_HVS_REFERRALS"] = "ri.HVSRefVwr";
    eUserRole["MANAGE_HVS_REFERRALS"] = "ri.HVSRefMngr";
    eUserRole["VIEW_MTC_REFERRALS"] = "ri.MTCRefVwr";
    eUserRole["MANAGE_MTC_REFERRALS"] = "ri.MTCRefMngr";
    eUserRole["VIEW_ORINOCO_REFERRALS"] = "ri.orinRefVwr";
    eUserRole["MANAGE_ORINOCO_REFERRALS"] = "ri.orinRefMngr";
    eUserRole["CLAIM_MANAGER_TWO"] = "ri.claimMngr2";
    eUserRole["ASSIGN_USER_ROLES"] = "ri.userRoles";
    eUserRole["SHARED_ACCESS"] = "ri.sharedAccess";
})(eUserRole = exports.eUserRole || (exports.eUserRole = {}));
exports.default = role_class_1.default;
//# sourceMappingURL=index.js.map